var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWwApplePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "980px",
    height: "680px",
    viewBox: "0 0 980 680",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WW Apple Pay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    rx: 80
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.7%",
    y: "-10.0%",
    width: "113.3%",
    height: "120.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WW-Apple-Pay",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(44.0587, 136)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.175099,42.3486014 C136.799025,53.4436224 121.797306,62.1946249 106.795588,60.9444817 C104.920373,45.9427631 112.264964,30.0034371 120.859699,20.1585593 C130.235773,8.7510025 146.643903,0.625071607 159.926674,0 C161.489353,15.6267902 155.394905,30.9410446 146.175099,42.3486014 M159.770406,63.9135718 C138.049168,62.6634286 119.453288,76.2587361 109.139606,76.2587361 C98.6696567,76.2587361 82.8865986,64.5386434 65.6971294,64.8511793 C43.3508194,65.1637151 22.5671885,77.8214151 11.1596317,97.9799744 C-12.2805536,138.297093 5.0651835,197.991432 27.7240293,230.807691 C38.8190503,247.059553 52.1018219,264.874094 69.6038269,264.249022 C86.1682245,263.62395 92.7314764,253.466537 112.733768,253.466537 C132.892327,253.466537 138.67424,264.249022 156.176245,263.936486 C174.303321,263.62395 185.710878,247.684624 196.805899,231.432763 C209.463599,212.99315 214.62044,195.022341 214.932976,194.084734 C214.62044,193.772198 179.928966,180.489427 179.61643,140.484844 C179.303894,107.043513 206.963313,91.1041868 208.213456,90.1665793 C192.586666,67.0389299 168.208873,64.5386434 159.770406,63.9135718 M285.253531,18.5958803 L285.253531,262.217539 L323.070364,262.217539 L323.070364,178.926748 L375.420111,178.926748 C423.238089,178.926748 456.835688,146.110488 456.835688,98.605046 C456.835688,51.0996039 423.86316,18.5958803 376.670254,18.5958803 L285.253531,18.5958803 Z M323.070364,50.4745323 L366.669108,50.4745323 C399.485368,50.4745323 418.237516,67.9765373 418.237516,98.7613139 C418.237516,129.546091 399.485368,147.204364 366.51284,147.204364 L323.070364,147.204364 L323.070364,50.4745323 L323.070364,50.4745323 Z M525.9061,264.092754 C549.658821,264.092754 571.692595,252.060126 581.693741,232.995442 L582.475081,232.995442 L582.475081,262.217539 L617.479091,262.217539 L617.479091,140.953647 C617.479091,105.79337 589.350868,83.1345238 546.06466,83.1345238 C505.903809,83.1345238 476.212907,106.105905 475.119032,137.672021 L509.185435,137.672021 C511.998257,122.670303 525.9061,112.825425 544.970784,112.825425 C568.098434,112.825425 581.06867,123.60791 581.06867,143.453934 L581.06867,156.892973 L533.875763,159.705796 C489.964483,162.36235 466.211762,180.333159 466.211762,211.586739 C466.211762,243.152855 490.745822,264.092754 525.9061,264.092754 Z M536.063514,235.183192 C515.904955,235.183192 503.090987,225.494582 503.090987,210.649132 C503.090987,195.334877 515.436151,186.427607 539.032604,185.021196 L581.06867,182.364641 L581.06867,196.116217 C581.06867,218.93133 561.69145,235.183192 536.063514,235.183192 Z M664.203193,328.47513 C701.082418,328.47513 718.428155,314.411018 733.586142,271.749881 L800,85.4785423 L761.558096,85.4785423 L717.021744,229.40128 L716.240405,229.40128 L671.704053,85.4785423 L632.168273,85.4785423 L696.238113,262.842611 L692.800219,273.625096 C687.018307,291.908441 677.642233,298.940496 660.921567,298.940496 C657.952477,298.940496 652.170565,298.62796 649.826546,298.315425 L649.826546,327.537522 C652.014297,328.162594 661.390371,328.47513 664.203193,328.47513 Z",
    id: "XMLID_34_"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwApplePay);
export default __webpack_public_path__ + "static/media/WW Apple Pay.8261eb3ca7aa2ff4267bc83f922d64b0.svg";
export { ForwardRef as ReactComponent };